module.exports = __webpack_public_path__ + "img/research_item_4.54c15d57.png";